(function() {
  'use strict';

  /* ---- Countdown Timer ---- */
  function initCountdown() {
    var el = document.querySelector('[data-sh-countdown]');
    if (!el) return;

    var h = parseInt(el.dataset.shHours || '2', 10);
    var m = parseInt(el.dataset.shMinutes || '47', 10);
    var s = parseInt(el.dataset.shSeconds || '32', 10);

    var stored = sessionStorage.getItem('sh_countdown_end');
    var end;
    if (stored && parseInt(stored, 10) > Date.now()) {
      end = parseInt(stored, 10);
    } else {
      end = Date.now() + (h * 3600 + m * 60 + s) * 1000;
      sessionStorage.setItem('sh_countdown_end', String(end));
    }

    var hEl = el.querySelector('[data-sh-h]');
    var mEl = el.querySelector('[data-sh-m]');
    var sEl = el.querySelector('[data-sh-s]');
    if (!hEl || !mEl || !sEl) return;

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function tick() {
      var diff = Math.max(0, Math.floor((end - Date.now()) / 1000));
      var hr = Math.floor(diff / 3600);
      var mn = Math.floor((diff % 3600) / 60);
      var sc = diff % 60;
      hEl.textContent = pad(hr);
      mEl.textContent = pad(mn);
      sEl.textContent = pad(sc);
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ---- FAQ Accordion ---- */
  function initFAQ() {
    var items = document.querySelectorAll('.sh-faq__item');
    items.forEach(function(item) {
      var btn = item.querySelector('.sh-faq__question');
      if (!btn) return;
      btn.addEventListener('click', function() {
        var isOpen = item.classList.contains('sh-faq--open');
        items.forEach(function(other) { other.classList.remove('sh-faq--open'); });
        if (!isOpen) item.classList.add('sh-faq--open');
      });
    });
    if (items.length > 0) items[0].classList.add('sh-faq--open');
  }

  /* ---- Stats Counter Animation ---- */
  function initStats() {
    var counters = document.querySelectorAll('[data-sh-count]');
    if (!counters.length) return;

    var animated = false;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && !animated) {
          animated = true;
          counters.forEach(function(el) {
            animateCounter(el);
          });
          observer.disconnect();
        }
      });
    }, { threshold: 0.3 });

    counters.forEach(function(el) { observer.observe(el); });
  }

  function animateCounter(el) {
    var final = el.dataset.shCount || '';
    var suffix = el.dataset.shSuffix || '';
    var prefix = el.dataset.shPrefix || '';
    var isPercent = final.indexOf('%') > -1;
    var numStr = final.replace(/[^0-9.]/g, '');
    var target = parseFloat(numStr) || 0;
    var isInt = target === Math.floor(target);
    var duration = 1800;
    var start = performance.now();

    function step(now) {
      var elapsed = now - start;
      var progress = Math.min(elapsed / duration, 1);
      var ease = 1 - Math.pow(1 - progress, 3);
      var current = target * ease;

      if (isInt) {
        el.textContent = prefix + formatNumber(Math.round(current)) + (isPercent ? '%' : '') + suffix;
      } else {
        el.textContent = prefix + current.toFixed(1) + (isPercent ? '%' : '') + suffix;
      }

      if (progress < 1) requestAnimationFrame(step);
      else el.textContent = prefix + final + suffix;
    }

    requestAnimationFrame(step);
  }

  function formatNumber(n) {
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ---- Reveal on Scroll ---- */
  function initReveal() {
    var els = document.querySelectorAll('.sh-reveal');
    if (!els.length) return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sh-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    els.forEach(function(el) { observer.observe(el); });
  }

  /* ---- Sticky Bar ---- */
  function initStickyBar() {
    var bar = document.querySelector('.sh-sticky-bar');
    if (!bar) return;
    var btn = bar.querySelector('.sh-sticky-bar__btn');
    if (!btn) return;

    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var form = document.querySelector('form[action*="/cart/add"]');
      if (form) {
        var submit = form.querySelector('[type="submit"], button[name="add"]');
        if (submit) { submit.click(); return; }
        form.requestSubmit ? form.requestSubmit() : form.submit();
      }
    });
  }

  /* ---- CTA Scroll-to-top ---- */
  function initCTAScroll() {
    document.querySelectorAll('[data-sh-scroll-top]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  }

  /* ---- Video Play Button ---- */
  function initVideoPlay() {
    document.querySelectorAll('.sh-hiw__video').forEach(function(container) {
      var video = container.querySelector('video');
      var playBtn = container.querySelector('.sh-hiw__play');
      if (!video || !playBtn) return;

      playBtn.addEventListener('click', function() {
        video.play();
        playBtn.style.display = 'none';
        var textEl = container.querySelector('.sh-hiw__play-text');
        if (textEl) textEl.style.display = 'none';
      });
    });
  }

  /* ---- Init All ---- */
  function init() {
    initCountdown();
    initFAQ();
    initStats();
    initReveal();
    initStickyBar();
    initCTAScroll();
    initVideoPlay();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
